import { render, staticRenderFns } from "./SignRecGiftList.vue?vue&type=template&id=bf0c0400"
import script from "./SignRecGiftList.vue?vue&type=script&lang=js"
export * from "./SignRecGiftList.vue?vue&type=script&lang=js"
import style0 from "./SignRecGiftList.vue?vue&type=style&index=0&id=bf0c0400&prod&lang=scss&module=true"
import style1 from "./SignRecGiftList.vue?vue&type=style&index=1&id=bf0c0400&prod&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports